























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';
import { vxm } from './../../store.vuex';
@Component({
  name: 'TimeSheetFilter',
  components: {
    Datepicker,
  },
})
export default class TimeSheetFilter extends Vue {
  $moment: any;
  @Prop({ default: 'saved', type: String }) tabName;
  @Prop({ default: '', type: String }) searchText;
  @Prop({ default: '', type: String }) startDateText;
  @Prop({ default: '', type: String }) endDateText;
  private startDateTextChild: string = '';
  private endDateTextChild: string = '';

  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }

  showDateFilter() {
    if (this.startDateText != '') this.startDateTextChild = this.startDateText;
    if (this.endDateText != '') this.endDateTextChild = this.endDateText;
    this.$bvModal.show('filter-' + this.tabName);
  }

  clearDateFilter() {
    this.startDateTextChild = '';
    this.endDateTextChild = '';
  }

  emitDates() {
    this.$emit('updatedates', this.startDateTextChild, this.endDateTextChild);
    this.$bvModal.hide('filter-' + this.tabName);
  }

  dateFormat(date) {
    return this.$moment(date).format(this.getCompanyDateFormat.toUpperCase());
  }

  clearSelectedFilter(entity) {
    if (entity === 'startDate') {
      this.startDateTextChild = '';
    }
    if (entity === 'endDate') {
      this.endDateTextChild = '';
    }
    this.$emit('updatedates', this.startDateTextChild, this.endDateTextChild);
  }
}
